'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './checkbox.module.scss';
const defaultInvalidHandler = (e)=>e.preventDefault();
export const Checkbox = ({ className, onInvalid = defaultInvalidHandler, ...props })=>/*#__PURE__*/ _jsxs("span", {
        className: classNames(styles.wrapper, className),
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "checkbox",
                ...props,
                className: classNames(styles.checkbox),
                onInvalid: onInvalid
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.checkmark,
                children: /*#__PURE__*/ _jsx("svg", {
                    className: styles.svg,
                    fill: "none",
                    height: "8",
                    viewBox: "0 0 10 8",
                    width: "10",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        className: styles.path,
                        d: "M1.5 5L4 7L8.5 1",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                })
            })
        ]
    });

//# sourceMappingURL=index.js.map